import { useEffect, useState } from 'react';
import { useMedia } from '@/hooks/useMedia';
import './product-hunt-badge.css';

export function ProductHuntBadge() {
  const isDesktop = useMedia('(min-width: 1001px)');
  const [heroVisible, setHeroVisible] = useState(false);

  useEffect(() => {
    if (!isDesktop) return;
    const hero = document.querySelector('.fx-hero');
    if (!hero) return;

    const observer = new IntersectionObserver(
      ([entry]) => setHeroVisible(entry.isIntersecting),
      { rootMargin: '-64px 0px 0px 0px' },
    );
    observer.observe(hero);
    return () => observer.disconnect();
  }, [isDesktop]);

  return (
    <a
      className="product-hunt-badge"
      hidden={isDesktop && !heroVisible}
      href="https://www.producthunt.com/products/foxet-ai?embed=true&amp;utm_source=badge-featured&amp;utm_medium=badge&amp;utm_campaign=badge-foxet-ai-2"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Foxet.ai on Product Hunt (opens in a new tab)"
    >
      {/* Custom badge, no vote count (owner, 2026-11-02): the widget image
          carried the live score. Link and tracking unchanged. */}
      <span className="product-hunt-badge__mark" aria-hidden="true">P</span>
      <span className="product-hunt-badge__text">
        <span className="product-hunt-badge__kicker">Find us on</span>
        <span className="product-hunt-badge__name">Product Hunt</span>
      </span>
    </a>
  );
}
